import axios from 'axios';

export const getBlobFromURL = async (url: string) => {
  const res = await axios.get<Blob>(url, { responseType: 'blob' });

  return res.data;
};
